import React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

function CustomTextButton({ anchorRef, title, handleClick, disabled = false }) {
  return (
    <Button
      ref={anchorRef}
      aria-controls={"text-button"}
      aria-expanded={"true"}
      aria-label="select merge strategy"
      aria-haspopup="menu"
      endIcon={<ArrowDropDownIcon />}
      onClick={handleClick}
      disabled={disabled}
    >
      <Typography variant="body2">
        {title}
      </Typography>
    </Button>
  );
}

export default CustomTextButton;
